import { useState } from "react";

/** A width kept in this browser; `null` until someone sets one. */
export function useStoredWidth(key: string) {
  const [width, setWidth] = useState<number | null>(() => {
    try {
      const n = Number(localStorage.getItem(key) ?? NaN);
      return Number.isFinite(n) ? n : null;
    } catch {
      return null;
    }
  });
  const keep = (next: number) => {
    setWidth(next);
    try {
      localStorage.setItem(key, String(next));
    } catch {
      // Blocked storage only costs remembering it.
    }
  };
  return [width, keep] as const;
}
